import { useTranslation } from 'utils/i18n';

const Spinner = ({ className = 'spinner' }: { className?: string }) => {
  const { t } = useTranslation('common');

  return (
    <img
      className={className}
      src="/images/spinner.gif"
      alt={t('please_wait')}
      data-testid="loadingSpinner"
    />
  );
};

export default Spinner;
